import styled from "styled-components";

export const FooterComponent = styled.footer`
  background-color: ${({theme}) => theme.colors.alternate};
  color: ${({theme}) => theme.colors.basic};
  min-height: 800px;
  position: relative;
  text-align: center;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 700px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 600px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 500px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 400px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    background: linear-gradient(#111A51, #030510);
  }
`;

export const ImgIllustration = styled.div`
  position: absolute;
  right: -145px;
  top: -145px;
  width: 290px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    right: -120px;
    top: -120px;
    width: 240px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    right: -105px;
    top: -105px;
    width: 210px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    right: -90px;
    top: -90px;
    width: 180px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    right: -75px;
    top: -75px;
    width: 150px;
  }
`;

export const RingImg = styled.img`
  width: 100%;
`;

export const StyledLogo = styled.div`
  padding-top: 450px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding-top: 370px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding-top: 330px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding-top: 280px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding-top: 240px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    padding-top: 420px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding-top: 320px;
  }
`;

export const LogoImg = styled.img`
  width: 162px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 150px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 125px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 120px;
  }
`;

export const AddressSection = styled.address`
  font-family: "RubikLight";
  font-style: normal;
  line-height: ${({theme}) => theme.lineHeight.subHeight};
  margin-top: 52px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    margin-top: 44px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    line-height: ${({theme}) => theme.lineHeight.hdPrimaryHeight};
    margin-top: 36px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    margin-top: 32px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    line-height: ${({theme}) => theme.lineHeight.smallHeight};
  }
`;

export const CallusSection = styled.div`
  font-family: "RubikLight";
  line-height: ${({theme}) => theme.lineHeight.primaryHeight};
  margin-top: 16px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    line-height: ${({theme}) => theme.lineHeight.hdPrimaryHeight};
    margin-top: 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    margin-top: 10px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    line-height: ${({theme}) => theme.lineHeight.smallHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    line-height: ${({theme}) => theme.lineHeight.smallerHeight};
  }
  a {
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid ${({theme}) => theme.colors.basic};
    }
  }
`;

export const SocialLinks = styled.ul`
  display: flex;
  justify-content: space-between;
  margin: 52px auto;
  width: 270px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin: 44px auto;
    width: 230px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 36px auto;
    width: 200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 32px auto;
    width: 180px;
  }
`;

export const Li = styled.li`
  svg {
    font-size: ${({theme}) => theme.fonts.subTitle};
    transition: all .2s ease-in-out;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdSubTitle};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.secondarySize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
    }
    &:hover {
      color: ${({theme}) => theme.colors.secondary};
    }
  }
`;

export const Title = styled.div`
  font-family: "RubikLight";
  line-height: ${({theme}) => theme.lineHeight.primaryHeight};
  margin-bottom: 56px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    line-height: ${({theme}) => theme.lineHeight.hdPrimaryHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-bottom: 60px;
  }
  a {
    border-bottom: 1px solid transparent;
    font-family: "RubikLight";
    &:hover {
      border-bottom: 1px solid ${({theme}) => theme.colors.basic};
      color: ${({theme}) => theme.colors.secondary};
    }
  }
`;

export const CopyRights = styled.div`
  align-items: center;
  border-top: 1px solid ${({theme}) => theme.colors.basic};
  display: flex;
  font-family: "RubikLight";
  font-size: ${({theme}) => theme.fonts.smallSize};
  justify-content: center;
  line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
  margin: 0 auto;
  padding: 52px 0;
  width: 1400px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    font-size: ${({theme}) => theme.fonts.smallerSize};
    line-height: ${({theme}) => theme.lineHeight.secondaryHeight};
    padding: 46px 0;
    width: 1200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    font-size: ${({theme}) => theme.fonts.smallestSize};
    line-height: ${({theme}) => theme.lineHeight.defaultHeight};
    padding: 40px 0;
    width: 1060px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    font-size: ${({theme}) => theme.fonts.dsmallSize};
    line-height: ${({theme}) => theme.lineHeight.smallerHeight};
    padding: 32px 0;
    width: 900px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    max-width: 800px;
    padding: 28px 0;
    width: 97%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    max-width: 80%;
    padding: 32px 0;
    width: 80%;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    font-size: 10px;
    max-width: 310px;
    padding: 32px 0;
    width: 310px;
  }
  svg {
    margin-right: 8px;
  }
`;
